import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ClientTable = ({ clients, onViewProfile, onGenerateQuote, onViewHistory, onUpdateCategory, onSort, sortConfig }) => {
  const getCategoryColor = (category) => {
    switch (category) {
      case 'individual':
        return 'bg-blue-100 text-blue-800';
      case 'professional':
        return 'bg-green-100 text-green-800';
      case 'subcontractor':
        return 'bg-purple-100 text-purple-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('fr-FR', {
      style: 'currency',
      currency: 'EUR'
    })?.format(amount);
  };

  const formatDate = (date) => {
    return new Intl.DateTimeFormat('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    })?.format(new Date(date));
  };

  const getSortIcon = (column) => {
    if (sortConfig?.key !== column) return 'ArrowUpDown';
    return sortConfig?.direction === 'asc' ? 'ArrowUp' : 'ArrowDown';
  };

  const handleSort = (column) => {
    onSort(column);
  };

  return (
    <div className="bg-surface border border-border rounded-lg overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-muted border-b border-border">
            <tr>
              <th className="text-left p-4">
                <button
                  onClick={() => handleSort('name')}
                  className="flex items-center space-x-2 text-sm font-medium text-text-primary hover:text-primary transition-smooth"
                >
                  <span>Client</span>
                  <Icon name={getSortIcon('name')} size={14} />
                </button>
              </th>
              <th className="text-left p-4">
                <button
                  onClick={() => handleSort('category')}
                  className="flex items-center space-x-2 text-sm font-medium text-text-primary hover:text-primary transition-smooth"
                >
                  <span>Catégorie</span>
                  <Icon name={getSortIcon('category')} size={14} />
                </button>
              </th>
              <th className="text-left p-4">
                <span className="text-sm font-medium text-text-primary">Contact</span>
              </th>
              <th className="text-left p-4">
                <button
                  onClick={() => handleSort('totalValue')}
                  className="flex items-center space-x-2 text-sm font-medium text-text-primary hover:text-primary transition-smooth"
                >
                  <span>Valeur totale</span>
                  <Icon name={getSortIcon('totalValue')} size={14} />
                </button>
              </th>
              <th className="text-left p-4">
                <button
                  onClick={() => handleSort('lastInteraction')}
                  className="flex items-center space-x-2 text-sm font-medium text-text-primary hover:text-primary transition-smooth"
                >
                  <span>Dernière interaction</span>
                  <Icon name={getSortIcon('lastInteraction')} size={14} />
                </button>
              </th>
              <th className="text-right p-4">
                <span className="text-sm font-medium text-text-primary">Actions</span>
              </th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {clients?.map((client) => (
              <tr key={client?.id} className="hover:bg-muted/50 transition-smooth">
                <td className="p-4">
                  <div>
                    <div className="font-medium text-text-primary">
                      {client?.firstName} {client?.lastName}
                    </div>
                    <div className="text-sm text-text-secondary">{client?.address}</div>
                  </div>
                </td>
                <td className="p-4">
                  <span className={`px-2 py-1 text-xs font-medium rounded-full ${getCategoryColor(client?.category)}`}>
                    {client?.category === 'individual' ? 'Particulier' : 
                     client?.category === 'professional' ? 'Professionnel' : 'Sous-traitant'}
                  </span>
                </td>
                <td className="p-4">
                  <div className="space-y-1 text-sm text-text-secondary">
                    <div className="flex items-center space-x-2">
                      <Icon name="Mail" size={12} />
                      <span>{client?.email}</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <Icon name="Phone" size={12} />
                      <span>{client?.phone}</span>
                    </div>
                  </div>
                </td>
                <td className="p-4">
                  <div className="font-medium text-text-primary">
                    {formatCurrency(client?.totalValue)}
                  </div>
                  <div className="text-sm text-text-secondary">
                    {client?.totalQuotes} devis
                  </div>
                </td>
                <td className="p-4">
                  <div className="text-sm text-text-primary">
                    {formatDate(client?.lastInteraction)}
                  </div>
                </td>
                <td className="p-4">
                  <div className="flex items-center justify-end space-x-1">
                    <Button
                      variant="ghost"
                      size="sm"
                      iconName="Eye"
                      onClick={() => onViewProfile(client)}
                      title="Voir le profil"
                    />
                    <Button
                      variant="ghost"
                      size="sm"
                      iconName="FileText"
                      onClick={() => onViewHistory(client)}
                      title="Historique des devis"
                    />
                    <Button
                      variant="outline"
                      size="sm"
                      iconName="Calculator"
                      onClick={() => onGenerateQuote(client)}
                      title="Nouveau devis"
                    />
                    <Button
                      variant="ghost"
                      size="sm"
                      iconName="Settings"
                      onClick={() => onUpdateCategory(client)}
                      title="Modifier la catégorie"
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ClientTable;